<template>
  <div v-if="analisis">
    <h1>Detalle del Análisis</h1>
    <p><strong>ID:</strong> {{ analisis.id }}</p>
    <p><strong>Tipo de Análisis:</strong> {{ analisis.tipo_analisis.nombre }}</p>
    <p><strong>Fecha de Análisis:</strong> {{ new Date(analisis.fecha_analisis).toLocaleDateString() }}</p>
    <p><strong>Realizado por:</strong> {{ analisis.realizado_por }}</p>
    <p><strong>Método:</strong> {{ analisis.metodo }}</p>
    <p><strong>Observaciones:</strong> {{ analisis.observaciones }}</p>
    <p><strong>Aprobado:</strong> {{ analisis.aprobado ? 'Sí' : 'No' }}</p>
    <h2>Resultados</h2>
    <ul>
      <li v-for="resultado in analisis.resultados" :key="resultado.id">
        {{ resultado.nombre_parametro }}: {{ resultado.valor }} {{ resultado.unidad_medida }}
        (Referencia: {{ resultado.referencia_min }} - {{ resultado.referencia_max }})
      </li>
    </ul>
    <h2>Archivos</h2>
    <ul>
      <li v-for="archivo in analisis.archivos" :key="archivo.id">
        <a :href="archivo.url" target="_blank">{{ archivo.nombre }}</a>
      </li>
    </ul>
    <div v-if="error" class="error">
      {{ error }}
    </div>
  </div>
  <div v-else>
    <p>Cargando detalles del análisis...</p>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  data() {
    return {
      analisis: null,
      error: null,
    };
  },
  methods: {
    async fetchAnalisisDetalle() {
      try {
        const { id } = this.$route.params;
        const response = await axios.get(`/api/analisis/${id}`);
        this.analisis = response.data;
      } catch (error) {
        this.error = 'Error al cargar los detalles del análisis';
      }
    },
  },
  mounted() {
    this.fetchAnalisisDetalle();
  },
};
</script>

<style scoped>
.error {
  color: red;
}
</style>
